module.exports = __webpack_public_path__ + "static/video_1-b4ae91891a642088bb0a0221008d7af0.webm";